module.exports = __webpack_public_path__ + "static/media/down_filled.40ce16d2.svg";